import { useState } from "react";
import { handleError } from "../../../Utils";

const ChooseTime = ({
  isVisible,
  setIsVisible,
  weekDaysAndTime,
  setWeekDaysAndTime,
  index,
}) => {
  const [selectedTimes, setSelectedTimes] = useState([]);

  const generateTimeOptions = () => {
    const times = [];
    let hours = 0;
    let minutes = 0;

    while (hours < 24) {
      const period = hours < 12 ? "AM" : "PM";
      const displayHour = hours % 12 === 0 ? 12 : hours % 12;
      const displayMinute = minutes < 10 ? `0${minutes}` : minutes;

      const timeString = `${displayHour}:${displayMinute} ${period}`;

      times.push({
        value: timeString,
        label: timeString,
      });

      minutes += 5;
      if (minutes === 60) {
        minutes = 0;
        hours++;
      }
    }

    return times;
  };

  const timeOptions = generateTimeOptions();

  const toggleTimeSelection = (time) => {
    setSelectedTimes((prev) => {
      if (prev.some((t) => t.value === time.value)) {
        return prev.filter((t) => t.value !== time.value);
      } else {
        return [...prev, time];
      }
    });
  };

  const handleSlotTime = () => {
    if (weekDaysAndTime.length === 0) {
      return handleError("Please select the date first!");
    }

    setWeekDaysAndTime((prevSlotDate) => {
      const updatedSlotDate = [...prevSlotDate];
      const selectedDateEntry = updatedSlotDate[index];

      const existingTimes = selectedDateEntry.time.map((t) => t.value);

      const newTimes = selectedTimes.filter(
        (time) => !existingTimes.includes(time.value)
      );

      const combinedTimes = [...selectedDateEntry.time, ...newTimes];

      const convertToMinutes = (timeString) => {
        const [hourMinute, period] = timeString.split(" ");
        const [hour, minute] = hourMinute.split(":").map(Number);
        let h = hour;
        if (period === "PM" && hour !== 12) h += 12;
        if (period === "AM" && hour === 12) h = 0;
        return h * 60 + minute;
      };

      selectedDateEntry.time = combinedTimes.sort(
        (a, b) =>
          convertToMinutes(a.value || a.label) -
          convertToMinutes(b.value || b.label)
      );
      selectedDateEntry.slots = selectedDateEntry.time.length;

      updatedSlotDate[index] = selectedDateEntry;
      return updatedSlotDate;
    });

    setSelectedTimes([]);
    setIsVisible(false);
  };

  return (
    isVisible && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 overflow-auto">
        <div className="mt-4 bg-white p-6 rounded-lg shadow-lg max-w-[500px] w-full max-h-[90vh] overflow-y-auto mx-2">
          <h2 className="text-lg font-semibold mb-4 text-center">Choose Time</h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 max-h-[400px] overflow-y-auto">
            {timeOptions.map((time, idx) => (
              <label
                key={idx}
                className="flex items-center space-x-2 text-sm border p-1 rounded hover:bg-gray-100 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={selectedTimes.some((t) => t.value === time.value)}
                  onChange={() => toggleTimeSelection(time)}
                />
                <span>{time.label}</span>
              </label>
            ))}
          </div>

          <div className="flex justify-between gap-4 mt-6">
            <button
              className="px-4 py-2 bg-gray-300 text-black rounded-md hover:bg-gray-400"
              onClick={() => {
                setSelectedTimes([]);
                setIsVisible(false);
              }}
            >
              Close
            </button>
            <button
              className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
              onClick={handleSlotTime}
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default ChooseTime;
